import React from "react";
import { AppStoreBadge, PlayStoreBadge } from "./StoreBadges";
import PhoneMockup, {
  RealScreenHome,
  RealScreenPodium,
  RealScreenSignIn,
} from "./PhoneMockup";
import { ASSETS } from "./assets";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 pb-20 lg:pt-32 lg:pb-24 overflow-hidden"
    >
      {/* Background image with heavy overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/32897040/pexels-photo-32897040.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/85 to-black" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div
            className="inline-flex items-center gap-2 border border-[#D4F34A]/40 rounded-full px-3 py-1 mb-6"
            data-testid="hero-badge"
          >
            <span className="w-2 h-2 rounded-full bg-[#D4F34A] animate-pulse" />
            <span className="text-[10px] uppercase tracking-widest text-[#D4F34A]">
              Now live on iOS & Android
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display uppercase tracking-tight text-6xl sm:text-7xl md:text-8xl lg:text-[7.5rem] leading-[0.85]"
          >
            Your padel.
            <br />
            Your score.
            <br />
            <span className="text-[#D4F34A]">Your game.</span>
          </h1>

          <p
            data-testid="hero-subtext"
            className="mt-6 text-base sm:text-lg text-neutral-300 max-w-xl leading-relaxed"
          >
            Run Americano tournaments, score live matches point-by-point, and
            track your career stats — all from your phone.
          </p>

          <div
            id="download"
            data-testid="hero-cta-group"
            className="mt-8 flex flex-wrap items-center gap-3"
          >
            <AppStoreBadge testId="cta-app-store" />
            <PlayStoreBadge testId="cta-play-store" />
          </div>

          <div
            className="mt-10 flex items-center gap-6"
          >
            <div>
              <div className="font-display text-3xl">12K+</div>
              <div className="text-[10px] uppercase tracking-widest text-neutral-500">
                Players scoring
              </div>
            </div>
            <div className="w-px h-10 bg-neutral-800" />
            <div>
              <div className="font-display text-3xl">840+</div>
              <div className="text-[10px] uppercase tracking-widest text-neutral-500">
                Tournaments run
              </div>
            </div>
            <div className="w-px h-10 bg-neutral-800" />
            <div>
              <div className="font-display text-3xl text-[#D4F34A]">4.9</div>
              <div className="text-[10px] uppercase tracking-widest text-neutral-500">
                App rating
              </div>
            </div>
          </div>
        </div>

        {/* Phone mockups cluster */}
        <div className="lg:col-span-5 relative h-[560px] hidden lg:block">
          <div
            className="absolute top-8 left-0 w-[220px] h-[460px]"
          >
            <PhoneMockup testId="hero-phone-1" tilt={-8}>
              <RealScreenPodium />
            </PhoneMockup>
          </div>
          <div
            className="absolute top-0 left-1/2 -translate-x-1/2 w-[240px] h-[500px] z-20"
          >
            <PhoneMockup testId="hero-phone-2">
              <RealScreenHome />
            </PhoneMockup>
          </div>
          <div
            className="absolute top-8 right-0 w-[220px] h-[460px]"
          >
            <PhoneMockup testId="hero-phone-3" tilt={8}>
              <RealScreenSignIn />
            </PhoneMockup>
          </div>
        </div>

        {/* Mobile: single centered phone */}
        <div className="lg:hidden mt-10 flex justify-center">
          <div className="w-[240px] h-[500px]">
            <PhoneMockup testId="hero-phone-mobile">
              <RealScreenHome />
            </PhoneMockup>
          </div>
        </div>
      </div>
    </section>
  );
}
